export default {
    // imgUrl: "http://192.168.1.10:8091",
    imgUrl: "https://gov.dangjian.link",
}